// extracted by mini-css-extract-plugin
module.exports = {"items":"items_items__3zFWK"};